/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { AppRouteInterface, RouteInterface, RouteInterfaceMin } from '../types/routes';
import { AppConfig } from '../types/app';
import queryString from 'query-string';
import { generatePath as generatePathV6 } from 'react-router-dom-v5-compat';
import { generatePath } from 'react-router-dom';

type IncomingParams = { [key: string]: string | undefined };

interface AdditionalParams {
  [key: string]: string | number | string[] | undefined
}

export const generateUrl = (route: RouteInterfaceMin, incomingParams?: IncomingParams) => {
  const params: { [key: string]: string } = {};

  if (route.defaultParams) {
    Object.keys(route.defaultParams).forEach(k => params[k] = route.defaultParams?.[k] ?? '');
  }
  if (route.getRootAppPath) {
    params.rootAppPath = route.getRootAppPath()
  }

  if (incomingParams) {
    Object.keys(incomingParams).forEach(key => {
      const v = incomingParams[key];
      if (v !== undefined && v !== '') {
        params[key] = v;
      }
    });
  }

  if (route.isRouterV6 === true) {
    return generatePathV6(route.path, params);
  }
  return generatePath(route.path, params);
}

export const generateUrlWithQuery = (route: RouteInterfaceMin, incomingParams: IncomingParams, queryParams: AdditionalParams) => {
  const url = generateUrl(route, incomingParams);
  const query = queryString.stringify(queryParams);
  return query ? `${url}?${query}` : url;
}

export const getAppRoute = (route: AppRouteInterface, appConfig: AppConfig | undefined): AppRouteInterface => {

  if (!appConfig) {
    return route
  }

  const rootAppPathGetter = appConfig.rootAppPath ? (() => appConfig.rootAppPath) : undefined

  return {
    ...route,
    appName: appConfig.name || route.appName,
    appIcon: appConfig.logo || route.appIcon,
    headerIcon: appConfig.whitelabel?.logo || route.headerIcon,
    productCode: appConfig.productCode,
    routes: route.routes?.reduce((a, r) => {
      if (rootAppPathGetter) {
        return [...a, { ...r, getRootAppPath: rootAppPathGetter }];
      }
      return [...a, r];
    }, [] as RouteInterface[])
  };
};

export const shouldRedirectToAppPath = (rootAppPath: string, appConfig: AppConfig | undefined): appConfig is AppConfig => {
  if (!appConfig?.rootAppPath) {
    return false
  }
  return appConfig.rootAppPath !== rootAppPath;
};
